/*
 * @Description:
 * @Version: 1.0
 * @Author: changfeng
 * @Date: 2024-04-18 15:13:10
 * @LastEditors: changfeng
 * @LastEditTime: 2024-10-09 10:38:46
 */
export default {
	"account.title": "授权管理",
	"account.blank.message": "规则通过自动跟踪您的广告投放效果和执行动作，帮助您减少在广告管理上花费的时间\n",
	"account.blank.button": "连接Meta账户",

	"account.profile.card1.title": "已授权",
	"account.profile.card1.message": "授权",
	"account.profile.card1.modal.title": "已授权",
	"account.profile.card1.modal.button": "取消连接",
	"account.profile.card2.title": "新增授权用户",
	"account.profile.tips": "这是安全的，AdSurgebot不会收集和存储您的个人数据。",
	"account.profile.unlink.modal.title": "取消授权用户？",
	"account.profile.unlink.modal.text1": "取消连接 ",
	"account.profile.unlink.modal.text2": " 授权用户，所有广告账户将与AdSurgebot断开连接。此操作会影响与广告账户关联的对象：",
	"account.profile.unlink.modal.text.tip": "自动化规则将被停止。",
	"account.profile.unlink.modal.text.button.ok": "取消授权",
	"account.profile.unlink.modal.text.remove.success": "移除成功",
	"account.member.no permission.profile": "您无权授权用户,只有组织中具有“Owner”角色的成员才能执行此操作。",

	"account.table.title": "广告账户列表",
	"account.table.description": "选择您想要连接的Meta广告账户",
	"account.table.search.name.placeholder": "请输入广告账户名称或ID",
	"account.table.search.profile.placeholder": "全部授权用户",
	"account.table.search.profile.choice1": "全部授权用户",
	"account.table.search.account.placeholder": "全部广告账户",
	"account.table.search.account.choice1": "全部广告账户",
	"account.table.search.account.choice2": "已连接",
	"account.table.search.account.choice3": "未连接",
	"account.table.search.connectedAccount": "已连接的账户数量：",
	"account.table.connectedAccount.title": "已连接的账户",

	"account.table.sync.button": "同步",
	"account.table.sync.message.success": "这可能需要几分钟，您可以稍后查看。",
	"account.table.hidden.unit": "个广告账户",
	"account.table.hidden.text1": "被隐藏，无法连接。",
	"account.table.hidden.text2": "显示所有广告账号",
	"account.table.column.connected": "连接状态",
	"account.table.column.advName": "广告账户名称",
	"account.table.column.status": "账户状态",
	"account.table.column.status.tips": "广告账户状态来自 Facebook Ads Manager",
	"account.table.column.advId": "广告账户ID",

	"account.table.column.status.enable": "正常",
	"account.table.column.status.Restricted": "禁用",

	"account.table.disconnect.modal.title": "断开广告账户的连接？",
	"account.table.disconnect.modal.text": "此操作会影响与广告账户关联的对象：",
	"account.table.disconnect.modal.text.item": "· 自动化规则将被停止",

	"account.table.operation.view binding": "查看绑定规则"
};
